import React, { useContext } from 'react';
import './NewProduct.scss';
import { useState } from 'react';
import arrowImg from './AssetsNewProduct/Arrow.svg';

import DeleteIcon from './AssetsNewProduct/DeleteIcon.svg';
import ViewEye from './AssetsNewProduct/ViewEye.svg';
import ProductsIcon from './AssetsNewProduct/ProductsIcon.svg';
import UploadProductIcon from './AssetsNewProduct/UploadProductIcon.svg';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { uiContext } from '../common';
import Moment from 'moment';

import regionDataJson from '../../assets/regiones.json';
import {API} from '../../services/api';

const NewProduct = () => {
    /**
     * Vista para agregar y mostrar los productos
     * Hay un formulario para poder escojer la imagen y enviar los dato al servidor
     * Se cargan los productos y se renderizan en una tabla
     */
    const history = useHistory();
    const uicontext = useContext(uiContext);
    const [section, setSection] = useState(0);
    const [varSessionToken, setVarSessionToken] = useState("");

    const [productName, setProductName] = useState("");
    const [photoUrl, setPhotoUrl] = useState("");

    const [productsList, setProductsList] = useState([]);

    const [regionSelect, setRegionSelect] = useState([]);
    const [regionKey, setRegionKey] = useState(regionDataJson[0].region);

    useEffect(() => {
        let regionOptions = [];
        for (let i = 0; i < regionDataJson.length; i++) {
            regionOptions.push(<option value={regionDataJson[i].region} key={regionDataJson[i].region}>{regionDataJson[i].region}</option>);
        }
        setRegionSelect(regionOptions);
        setRegionKey(regionDataJson[0].region);

        let sessionToken = localStorage.getItem("sessionToken");
        if (sessionToken != null) {
            setVarSessionToken(sessionToken);
        } else {
            history.push("/login");
        }
    }, []);


    const uploadPhoto = () => {
        //uicontext.showLoader();
        let input = document.createElement('input');
        input.type = 'file';
        input.accept = '.webp,.png,.jpg,.jpeg,.svg';
        input.click();
        input.onchange = () => {

            if (!input.files.length) {
                alert("File too big");
                uicontext.hideLoader();
                return;
            }
            var file = input.files[0];
            if ((file.size / 1024 / 1024) > 2) {
                alert("El peso de la imagen excede los 2MBs");
                uicontext.hideLoader();
                return;
            }

            uicontext.showLoader();
            /**
             * Subir imagen
             * Se hace el llamado al servicio /uploads/
             */
            API.postUploadFile(file)
                .then(x => {
                    setPhotoUrl(`${uicontext.API}/images/${x.filename}`);
                    uicontext.hideLoader();
                })
                .catch(x => {
                    uicontext.hideLoader();
                })
           
        }
    }

    const UploadProduct = () => {
        uicontext.showLoader();
        /**
         * Registrar producto
         * Se hace el llamado del servicio /products/register-product-for-user-in-session 
         */
        API.postRegisterProductForUserInSession({
            name: productName,
            photoUrl: photoUrl,
            sessionKey: varSessionToken,
            description: "-",
            regionKey: regionKey
        })
        .then(x => {
            setProductName("");
            setPhotoUrl("");
            setSection(1);
            getUserProducts();
            uicontext.hideLoader();
        })
        .catch(x =>{
            uicontext.hideLoader();
        })
    }

    const getUserProducts = () => {
        uicontext.showLoader();
        /**
         * Obtener productos
         * Se hace el llamado del servicio 
         */
        API.putProductsForUserInSession(varSessionToken)
            .then(x => {
                uicontext.hideLoader();
                setProductsList(x);
            })
            .catch(x =>{
                uicontext.hideLoader();
            })
    }

    const deleteElement = (_id) => {
        setSection(0);
        uicontext.showLoader();
        API.putRemoveProductForUserInSession({
            sessionKey:varSessionToken,
            productId:_id
        })
        .then(x => {
            uicontext.hideLoader();
        })
        .catch(x => {
            uicontext.hideLoader();
        });
    }

    const getDate = (objectId) => {
        return Moment(Date(parseInt(objectId.substring(0, 8), 16) * 1000)).format("DD / MMM / YYYY");
    }


    return (
        <div className="NewProductMasterContainer">
            <span className="title">Mis productos</span>
            <div className="productSection">
                <div className="returnContainer">
                    <div onClick={() => { history.push("/mi-perfil") }} className="returnSubContainer">
                        <img src={arrowImg} alt="arrow" className="boldArrow"></img >
                        <span className="arrowText">Volver</span>
                    </div>
                </div>
                <div className="buttonsContainer">
                    <div onClick={() => { setSection(0) }} className={(section === 0 ? "selectedButton productButton" : "productButton")}>
                        <img src={UploadProductIcon} alt="" />
                        <span>Agregar nuevo producto</span>
                    </div>

                    <div onClick={() => { setSection(1); getUserProducts(); }} className={(section === 1 ? "selectedButton productButton" : "productButton")}>
                        <img src={ProductsIcon} alt="" />
                        <span>Productos publicados</span>
                    </div>
                </div>

                {section === 0 && <div className="addProductSection">
                    <span className="subTitle">Nombre del producto</span>
                    <input value={productName} onChange={(event) => { setProductName(event.target.value); }} className="inputTitle" type="text" />

                    <div className="separator"></div>
                    <span className="subTitle">Región</span>
                    <div className="formField">
                        <select className="inputTitle" required value={regionKey} onChange={(event) => { setRegionKey(event.target.value); }}>
                            {regionSelect}
                        </select>
                    </div>

                    <div className="separator"></div>

                    <span className="subTitle">Suba un producto</span>
                    {photoUrl !== "" && <img className="previewImage" alt="producto" src={photoUrl} />}
                    <button onClick={() => { uploadPhoto(); }} className="selectImageButton">+Seleccione imagen...</button>

                    <button disabled={photoUrl.length <= 0 || productName.length <= 0} onClick={() => { UploadProduct(); }} className={(photoUrl.length > 0 && productName.length > 0 ? "uploadImageButton" : "uploadImageButton disabledButton")}>Subir</button>
                </div>}

                {section === 1 && < div className="productListSection">
                    <div className="tableHeader genericRowContainer">
                        <div className="spanContainer item">
                            <span className="titleHeader"></span>
                        </div>

                        <div className="spanContainer item">
                            <span className="titleHeader">Titulo</span>
                        </div>

                        <div className="spanContainer item">
                            <span className="titleHeader">Fecha</span>
                        </div>

                        <div className="spanContainer item">
                            <span className="titleHeader">Region</span>
                        </div>

                        <div className="spanContainer item">
                            <span className="titleHeader">Visualizar</span>
                        </div>

                        <div className="spanContainer item">
                            <span className="titleHeader">Eliminar</span>
                        </div>
                    </div>

                    {productsList.map(x => {
                        return(
                            <div className="genericRowContainer borderDownContainer" key={x._id}>
                                <div className="imageContainer item">
                                    <img className="listImage" src={x.photoUrl} alt="" />
                                </div>

                                <div className="spanContainer item">
                                    <span className="titleHeader">{x.name}</span>
                                </div>

                                <div className="spanContainer item">
                                    <span className="titleHeader">{getDate(x._id)}</span>
                                </div>

                                <div className="spanContainer item">
                                    <span className="titleHeader">{x.regionKey != null ? x.regionKey : "---"}</span>
                                </div>

                                <div className="spanContainer item">
                                    <img className="eyeImg" onClick={() => { history.push("perfil-visitante/" + x.userId); }} src={ViewEye} alt="" />
                                </div>

                                <div className="spanContainer item">
                                    <img className="deleteImg" onClick={() => { deleteElement(x._id) }} src={DeleteIcon} alt="" />
                                </div>
                            </div>
                        );
                    })}
                </div>}
            </div>
        </div>
    )
}

export default NewProduct;